import PetSmartLandingPage from './PetSmartLandingPage';

export default PetSmartLandingPage;
